import {
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import { supportEmail } from "../../consts/emails";
import { PaymentPlans } from "../paymentPlans/paymentPlans";
import { paymentPlansModalStyle } from "./paymentPlansModal.styles";

export const PaymentPlansModal = ({ isOpen, onClose, isFreeUser }) => {
  const classes = paymentPlansModalStyle();

  return (
    isOpen && (
      <Dialog
        data-testid="subscription-modal"
        className={classes.paymentModal}
        onClose={onClose}
        open={isOpen}
      >
        <DialogTitle className={classes.dialogTitle}>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <Grid container justifyContent="center">
            <Grid item xs={9} sm={12}>
              <Typography className={classes.title} align="center">
                Take your Money Mentorship ™ to the next level
              </Typography>
            </Grid>
            <Grid item>
              <PaymentPlans isFreeUser={isFreeUser} />
            </Grid>
            <Grid item className={classes.contactSupport}>
              <Typography align="center">Have questions?</Typography>
              <a href={supportEmail}>
                Contact support <ChevronRightIcon />
              </a>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    )
  );
};

PaymentPlansModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isFreeUser: PropTypes.bool.isRequired,
};
